import React, { useState, FunctionComponent, useEffect } from 'react'
import { Button, Space, Row, Col } from 'antd'
import { Link } from 'react-router'
import { Trader } from '../components/trader'
import { CoffeeOutlined, PlusOutlined } from '@ant-design/icons'
import { TradersService } from '../api/services.gen'
import { TraderDto } from '../api'

const TradersPage:FunctionComponent<{}> = (props) => {
  const [loading, setLoading] = useState<boolean>(true)

  const [traders, setTraders] = useState<TraderDto[]>([])

  const fetchTraders = async () => {
    setLoading(true)
    try {
      const response = await TradersService.getTraders()
      setTraders(response.traders)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTraders()
  }, [])

  return <>

    <div style={{ float: 'right'}}>
      <Button onClick={() => fetchTraders()} loading={loading}>Refresh</Button>
    </div>

    <h2>Traders</h2>
    <Row gutter={[16, 16]}>
      {
        traders.length === 0 ? <p>No trader</p> : null
      }
      {
        traders?.map(trader => <Col><Trader trader={trader} {...props} /></Col>)
      }
    </Row>
    <Link to="/traders/create"><Button type="primary" icon={<PlusOutlined />}>Create trader</Button></Link>
    <Link to="/traders/simulate"><Button icon={<CoffeeOutlined />}>Simulate trader</Button></Link>
    <br /><br />
  </>
}

export { TradersPage }
